import { useState } from 'react'
import PropTypes from 'prop-types'
import {
  statusIndicationMemberOptions,
  statusIndicationMemberVariantOptions
} from './constants'
import { Image, Container, ImageContainer } from './styled-components'
import {
  ContactEnclosed,
  MemberEnclosedDefault,
  TeamEnclosedDefault
} from '../icons/users'
import { iconSizeOptions } from '../icons/icons-sizes'
import StatusIndicationStatus from './components/status-indication-status'

const membersIconVariants = {
  [statusIndicationMemberVariantOptions.MEMBER]: MemberEnclosedDefault,
  [statusIndicationMemberVariantOptions.TEAM]: TeamEnclosedDefault,
  [statusIndicationMemberVariantOptions.CONTACT]: ContactEnclosed
}

const StatusIndicationComponent = ({
  variant = statusIndicationMemberVariantOptions.MEMBER,
  status = statusIndicationMemberOptions.NO_STATUS,
  iconColor,
  image,
  size
}) => {
  const IconComponent = membersIconVariants[variant]
  const [imageIsValid, setImageIsValid] = useState(true)

  if (image && imageIsValid) {
    return (
      <Container>
        <ImageContainer size={size}>
          <Image
            src={image}
            data-inactive={status === statusIndicationMemberOptions.INACTIVE}
            onError={() => setImageIsValid(false)}
          />
        </ImageContainer>
        <StatusIndicationStatus size={size} status={status} />
      </Container>
    )
  }

  return (
    <Container>
      <IconComponent size={size} stroke={iconColor} />
      <StatusIndicationStatus size={size} status={status} />
    </Container>
  )
}

StatusIndicationComponent.propTypes = {
  variant: PropTypes.oneOf(Object.values(statusIndicationMemberVariantOptions)),
  status: PropTypes.oneOf(Object.values(statusIndicationMemberOptions)),
  image: PropTypes.string,
  size: PropTypes.oneOf(Object.values(iconSizeOptions))
}

export default StatusIndicationComponent
